import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginScopes } from '../auth/msalConfig';

const styles: Record<string, React.CSSProperties> = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f0f4f8', fontFamily: 'system-ui, sans-serif' },
  card: { background: 'white', padding: '48px 40px', borderRadius: 8, boxShadow: '0 2px 12px rgba(0,0,0,0.1)', textAlign: 'center', maxWidth: 400 },
  title: { fontSize: 24, fontWeight: 700, color: '#1a365d', margin: '0 0 8px' },
  subtitle: { fontSize: 14, color: '#666', margin: '0 0 32px' },
  button: { background: '#0078d4', color: 'white', border: 'none', padding: '12px 24px', borderRadius: 4, fontSize: 15, cursor: 'pointer', fontWeight: 600 },
};

export default function LoginPage() {
  const { instance } = useMsal();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>CGS Expense Reports</h1>
        <p style={styles.subtitle}>Sign in to manage your expense reports</p>
        <button style={styles.button} onClick={() => instance.loginRedirect(loginScopes)}>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
